import { useDispatch } from "react-redux";
import { generatePreLoginToken, generatePostLoginToken, requestChat } from "../services/chatService.js";
import { IS_LOGIN, SOURCE_CHAT, SURVEY_BOT } from "../../constants.js";
import { setLoadingReply, updateExpiredAt } from "../features/messagesSlice.js";
import { setDeviceId, setCorrId, setToken, setSKey } from "../features/sessionSlice.js";
import { setSurveyLinkState } from "../features/surveySlice.js";
import { setCifId, setFullName, setIdNumber, setMobileNumber, setMobIsLogin, setPvPbFlag } from "../features/userDetailsSlice.js";
import { setIsTypingContainerState } from "../features/componentStateSlice.js";

export default function useRequestData() {
    const dispatch = useDispatch();

    const initializeChat = async () => {

        if (SOURCE_CHAT === "RIB") {
            var chatBtn = document.getElementById("idHiddenChatBtn");
            if (chatBtn != null) {
                chatBtn.click();
            }
        }
        
        dispatch(setLoadingReply(true));
        const requestData = await requestChat();
        dispatch(setDeviceId(requestData.deviceId));
        dispatch(setCorrId(requestData.correlation_id));
        dispatch(updateExpiredAt());

        let tokenResponse;
        if (IS_LOGIN) {
            tokenResponse = await generatePostLoginToken(requestData.correlation_id);
            dispatch(setMobIsLogin("Post Login"));
        } else {
            tokenResponse = await generatePreLoginToken(requestData.correlation_id);
        }

        dispatch(setToken(tokenResponse.token));
        dispatch(setSKey(tokenResponse.s_key));
        dispatch(setFullName(tokenResponse.name));
        dispatch(setMobileNumber(tokenResponse.mobileNumber));
        dispatch(setPvPbFlag(tokenResponse.pvpbFlag));
        dispatch(setCifId(tokenResponse.cid));
        dispatch(setIdNumber(tokenResponse.idNumber));
        dispatch(setSurveyLinkState(SURVEY_BOT));
        dispatch(setIsTypingContainerState(false));
    };

    return { initializeChat };
};
